import { createCustomInstance } from '@stepstone-genesis/components';

const genesisInstance = createCustomInstance({
  key: 'login-registration-provider',
});

export default genesisInstance;
